// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DEFINE hub — Requirements / Epics / Jira */

.rt-define-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.rt-define-panel__intro {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 4px;
}

.rt-define-panel__intro--compact {
  margin-bottom: 0;
}

.rt-define-panel__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 650;
  color: var(--text-primary);
}

.rt-define-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.rt-define-toolbar .rt-tabs {
  flex: 1 1 auto;
  min-width: 0;
}

.rt-define-toolbar .rt-filter-bar {
  margin: 0;
  flex: 0 1 280px;
}

/* ── Upload card ── */
.rt-define-upload__card {
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface);
  padding: 20px 22px;
  box-shadow: 0 1px 2px color-mix(in srgb, var(--text-primary) 4%, transparent);
}

.rt-define-upload__card .space-y-6 > * + * {
  margin-top: 1.25rem;
}

.rt-define-upload__card label,
.rt-define-upload__card .block {
  color: var(--text-primary);
}

.rt-define-upload__card input[type='text'],
.rt-define-upload__card input[type='email'],
.rt-define-upload__card input:not([type='file']):not([type='checkbox']):not([type='radio']) {
  width: 100%;
  padding: 0.55rem 0.85rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--input-background, var(--surface-2, var(--surface)));
  color: var(--text-primary);
  font: inherit;
}

.rt-define-upload__card input[readonly] {
  opacity: 0.85;
  cursor: not-allowed;
}

.rt-define-upload__card .border-2.border-dashed,
.rt-define-upload__card [class*='border-dashed'] {
  border-color: var(--border) !important;
  background: color-mix(in srgb, var(--surface-2, var(--surface)) 80%, transparent) !important;
  border-radius: 12px !important;
  color: var(--text-secondary, var(--text-primary));
}

.rt-define-upload__card .border-2.border-dashed:hover,
.rt-define-upload__card [class*='border-dashed']:hover {
  border-color: var(--primary, #2563eb) !important;
}

.rt-define-upload__card .bg-green-50,
.rt-define-upload__card .bg-blue-50,
.rt-define-upload__card .bg-gray-50,
.rt-define-upload__card .bg-red-50 {
  background: var(--surface-2, color-mix(in srgb, var(--surface) 92%, var(--text-primary) 4%)) !important;
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
}

.rt-define-upload__card .text-gray-900,
.rt-define-upload__card .text-gray-700,
.rt-define-upload__card .text-gray-600,
.rt-define-upload__card .text-gray-500,
.rt-define-upload__card .text-green-700,
.rt-define-upload__card .text-red-700 {
  color: var(--text-primary) !important;
}

.rt-define-upload__card .text-gray-500,
.rt-define-upload__card .text-xs.text-gray-500 {
  color: var(--text-secondary, color-mix(in srgb, var(--text-primary) 65%, transparent)) !important;
}

.rt-define-upload__card .flex.items-center.justify-end.gap-3 {
  border-color: var(--border) !important;
  margin-top: 1.25rem;
  padding-top: 1rem;
}

.rt-define-upload__card button.px-4.py-2.text-sm.font-medium.text-white.bg-blue-600,
.rt-define-upload__card button.inline-flex.items-center.px-4.py-2 {
  background: var(--primary, #2563eb) !important;
  border: none !important;
  border-radius: 8px !important;
  color: #fff !important;
}

.rt-define-upload__card button.px-4.py-2.text-sm.font-medium.text-gray-700 {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 8px !important;
  color: var(--text-primary) !important;
}

/* ── Jira host embed ── */
.rt-define-panel .rt-jira-host.jira-items-overlay,
.rt-legacy-embed .rt-jira-host.jira-items-overlay {
  position: relative !important;
  inset: auto !important;
  width: 100% !important;
  height: auto !important;
  min-height: 0 !important;
  background: transparent !important;
  padding: 0 !important;
  z-index: auto !important;
  overflow: visible !important;
}

.rt-define-panel .jira-items-container,
.rt-legacy-embed .jira-items-container {
  max-width: none !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
}

.rt-define-jira-toolbar,
.jira-items-tabs.rt-define-jira-toolbar {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
  background: transparent !important;
}

.rt-define-jira-tabs {
  display: flex;
  gap: 4px;
  align-items: center;
}

.rt-define-jira-tabs .tab-btn,
.rt-define-jira-toolbar .tab-btn {
  appearance: none;
  border: none;
  background: transparent;
  color: var(--text-secondary, color-mix(in srgb, var(--text-primary) 70%, transparent));
  font: inherit;
  font-size: 0.875rem;
  font-weight: 550;
  padding: 0.5rem 0.85rem;
  border-radius: 8px;
  cursor: pointer;
}

.rt-define-jira-tabs .tab-btn.active,
.rt-define-jira-toolbar .tab-btn.active {
  color: var(--primary, #2563eb);
  background: color-mix(in srgb, var(--primary, #2563eb) 12%, transparent);
  box-shadow: inset 0 -2px 0 var(--primary, #2563eb);
  border-radius: 8px 8px 0 0;
}

.rt-define-jira-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.rt-define-jira-actions .generate-all-scenarios-btn,
.rt-define-jira-actions .generate-all-tests-btn,
.rt-legacy-embed .generate-all-scenarios-btn,
.rt-legacy-embed .generate-all-tests-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.45rem 0.85rem;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-primary);
  font: inherit;
  font-size: 0.8125rem;
  font-weight: 550;
  cursor: pointer;
}

.rt-define-jira-actions .generate-all-tests-btn,
.rt-legacy-embed .generate-all-tests-btn {
  background: var(--primary, #2563eb);
  border-color: var(--primary, #2563eb);
  color: #fff;
}

.rt-define-jira-actions .generate-all-scenarios-btn:disabled,
.rt-define-jira-actions .generate-all-tests-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.rt-legacy-embed .jira-items-content,
.rt-define-panel .jira-items-content {
  background: transparent !important;
  padding: 0 !important;
}

.rt-legacy-embed .epic-item,
.rt-define-panel .epic-item,
.rt-legacy-embed .story-item-card,
.rt-define-panel .story-row {
  background: var(--surface) !important;
  border: 1px solid var(--border) !important;
  border-radius: 10px !important;
  color: var(--text-primary) !important;
  box-shadow: none !important;
}

.rt-legacy-embed .stories-table,
.rt-define-panel .stories-table {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  /* table chrome owned by rt2-jira-revamp — do not box every cell */
  box-shadow: none !important;
}

.rt-legacy-embed .epic-header,
.rt-define-panel .epic-header,
.rt-legacy-embed .epic-summary,
.rt-define-panel .epic-summary,
.rt-legacy-embed .story-summary,
.rt-define-panel .story-summary,
.rt-legacy-embed .jira-key,
.rt-define-panel .jira-key,
.rt-legacy-embed .pagination-info,
.rt-define-panel .pagination-info {
  color: var(--text-primary) !important;
}

.rt-legacy-embed .jira-key,
.rt-define-panel .jira-key {
  color: var(--primary, #2563eb) !important;
  font-weight: 600;
}

.rt-legacy-embed .epic-details,
.rt-define-panel .epic-details,
.rt-legacy-embed .epic-description,
.rt-define-panel .epic-description {
  color: var(--text-secondary, color-mix(in srgb, var(--text-primary) 70%, transparent)) !important;
  border-color: var(--border) !important;
}

.rt-legacy-embed .sync-epic-btn,
.rt-define-panel .sync-epic-btn,
.rt-legacy-embed .generate-tests-btn,
.rt-define-panel .generate-tests-btn,
.rt-legacy-embed .generate-scenarios-btn,
.rt-define-panel .generate-scenarios-btn {
  border-radius: 8px !important;
  border: 1px solid var(--border) !important;
  background: var(--surface) !important;
  color: var(--text-primary) !important;
}

.rt-legacy-embed .status-badge,
.rt-define-panel .status-badge,
.rt-legacy-embed .priority-badge,
.rt-define-panel .priority-badge {
  border-radius: 999px !important;
  border: 1px solid var(--border);
  background: color-mix(in srgb, var(--surface-2, var(--surface)) 90%, transparent) !important;
  color: var(--text-primary) !important;
}

.rt-legacy-embed table th,
.rt-define-panel table th {
  background: var(--surface-2, color-mix(in srgb, var(--surface) 92%, var(--text-primary) 5%)) !important;
  color: var(--text-secondary, var(--text-primary)) !important;
  border-color: var(--border) !important;
}

.rt-legacy-embed table td,
.rt-define-panel table td {
  border-color: var(--border) !important;
  color: var(--text-primary) !important;
  background: var(--surface) !important;
}

[data-theme='cloudlight'] .rt-define-upload__card,
:root:not([data-theme='midnight']) .rt-define-upload__card {
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

/* Dark-mode surfaces for Jira embed internals */
.rt-define-panel .jira-items-content,
.rt-legacy-embed .jira-items-content,
.rt-define-panel .epic-details,
.rt-legacy-embed .epic-details,
.rt-define-panel .epic-dropdown,
.rt-legacy-embed .epic-dropdown {
  background: var(--surface) !important;
  color: var(--text-primary) !important;
  border-color: var(--border) !important;
}

.rt-define-panel .epic-details h4,
.rt-define-panel .epic-stories h4,
.rt-define-panel .test-case-section h4,
.rt-legacy-embed .test-case-section h4 {
  background: transparent !important;
  box-shadow: none !important;
  text-shadow: none !important;
  color: var(--text-primary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-define.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,qEAAqE;EACrE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,sCAAsC;EACtC,4FAA4F;EAC5F,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;;;EAIE,uGAAuG;EACvG,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;;;;;;EAME,qCAAqC;AACvC;;AAEA;;EAEE,iGAAiG;AACnG;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,8CAA8C;EAC9C,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,sFAAsF;EACtF,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;EAC9B,wEAAwE;EACxE,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,qCAAqC;EACrC,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;;;;EAIE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,qCAAqC;EACrC,qCAAqC;EACrC,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;EAUE,qCAAqC;AACvC;;AAEA;;EAEE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;;;;EAIE,iGAAiG;EACjG,sCAAsC;AACxC;;AAEA;;;;;;EAME,6BAA6B;EAC7B,0CAA0C;EAC1C,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;;;;EAIE,+BAA+B;EAC/B,+BAA+B;EAC/B,4FAA4F;EAC5F,qCAAqC;AACvC;;AAEA;;EAEE,uGAAuG;EACvG,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;EACtC,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA,gDAAgD;AAChD;;;;;;EAME,qCAAqC;EACrC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;;;EAIE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;AACvC","sourcesContent":["/* DEFINE hub — Requirements / Epics / Jira */\n\n.rt-define-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n}\n\n.rt-define-panel__intro {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.rt-define-panel__intro--compact {\n  margin-bottom: 0;\n}\n\n.rt-define-panel__title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 650;\n  color: var(--text-primary);\n}\n\n.rt-define-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.rt-define-toolbar .rt-tabs {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.rt-define-toolbar .rt-filter-bar {\n  margin: 0;\n  flex: 0 1 280px;\n}\n\n/* ── Upload card ── */\n.rt-define-upload__card {\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--surface);\n  padding: 20px 22px;\n  box-shadow: 0 1px 2px color-mix(in srgb, var(--text-primary) 4%, transparent);\n}\n\n.rt-define-upload__card .space-y-6 > * + * {\n  margin-top: 1.25rem;\n}\n\n.rt-define-upload__card label,\n.rt-define-upload__card .block {\n  color: var(--text-primary);\n}\n\n.rt-define-upload__card input[type='text'],\n.rt-define-upload__card input[type='email'],\n.rt-define-upload__card input:not([type='file']):not([type='checkbox']):not([type='radio']) {\n  width: 100%;\n  padding: 0.55rem 0.85rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--input-background, var(--surface-2, var(--surface)));\n  color: var(--text-primary);\n  font: inherit;\n}\n\n.rt-define-upload__card input[readonly] {\n  opacity: 0.85;\n  cursor: not-allowed;\n}\n\n.rt-define-upload__card .border-2.border-dashed,\n.rt-define-upload__card [class*='border-dashed'] {\n  border-color: var(--border) !important;\n  background: color-mix(in srgb, var(--surface-2, var(--surface)) 80%, transparent) !important;\n  border-radius: 12px !important;\n  color: var(--text-secondary, var(--text-primary));\n}\n\n.rt-define-upload__card .border-2.border-dashed:hover,\n.rt-define-upload__card [class*='border-dashed']:hover {\n  border-color: var(--primary, #2563eb) !important;\n}\n\n.rt-define-upload__card .bg-green-50,\n.rt-define-upload__card .bg-blue-50,\n.rt-define-upload__card .bg-gray-50,\n.rt-define-upload__card .bg-red-50 {\n  background: var(--surface-2, color-mix(in srgb, var(--surface) 92%, var(--text-primary) 4%)) !important;\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-define-upload__card .text-gray-900,\n.rt-define-upload__card .text-gray-700,\n.rt-define-upload__card .text-gray-600,\n.rt-define-upload__card .text-gray-500,\n.rt-define-upload__card .text-green-700,\n.rt-define-upload__card .text-red-700 {\n  color: var(--text-primary) !important;\n}\n\n.rt-define-upload__card .text-gray-500,\n.rt-define-upload__card .text-xs.text-gray-500 {\n  color: var(--text-secondary, color-mix(in srgb, var(--text-primary) 65%, transparent)) !important;\n}\n\n.rt-define-upload__card .flex.items-center.justify-end.gap-3 {\n  border-color: var(--border) !important;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n}\n\n.rt-define-upload__card button.px-4.py-2.text-sm.font-medium.text-white.bg-blue-600,\n.rt-define-upload__card button.inline-flex.items-center.px-4.py-2 {\n  background: var(--primary, #2563eb) !important;\n  border: none !important;\n  border-radius: 8px !important;\n  color: #fff !important;\n}\n\n.rt-define-upload__card button.px-4.py-2.text-sm.font-medium.text-gray-700 {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 8px !important;\n  color: var(--text-primary) !important;\n}\n\n/* ── Jira host embed ── */\n.rt-define-panel .rt-jira-host.jira-items-overlay,\n.rt-legacy-embed .rt-jira-host.jira-items-overlay {\n  position: relative !important;\n  inset: auto !important;\n  width: 100% !important;\n  height: auto !important;\n  min-height: 0 !important;\n  background: transparent !important;\n  padding: 0 !important;\n  z-index: auto !important;\n  overflow: visible !important;\n}\n\n.rt-define-panel .jira-items-container,\n.rt-legacy-embed .jira-items-container {\n  max-width: none !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n  border-radius: 0 !important;\n}\n\n.rt-define-jira-toolbar,\n.jira-items-tabs.rt-define-jira-toolbar {\n  display: flex !important;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border);\n  background: transparent !important;\n}\n\n.rt-define-jira-tabs {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.rt-define-jira-tabs .tab-btn,\n.rt-define-jira-toolbar .tab-btn {\n  appearance: none;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary, color-mix(in srgb, var(--text-primary) 70%, transparent));\n  font: inherit;\n  font-size: 0.875rem;\n  font-weight: 550;\n  padding: 0.5rem 0.85rem;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.rt-define-jira-tabs .tab-btn.active,\n.rt-define-jira-toolbar .tab-btn.active {\n  color: var(--primary, #2563eb);\n  background: color-mix(in srgb, var(--primary, #2563eb) 12%, transparent);\n  box-shadow: inset 0 -2px 0 var(--primary, #2563eb);\n  border-radius: 8px 8px 0 0;\n}\n\n.rt-define-jira-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.rt-define-jira-actions .generate-all-scenarios-btn,\n.rt-define-jira-actions .generate-all-tests-btn,\n.rt-legacy-embed .generate-all-scenarios-btn,\n.rt-legacy-embed .generate-all-tests-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0.45rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  color: var(--text-primary);\n  font: inherit;\n  font-size: 0.8125rem;\n  font-weight: 550;\n  cursor: pointer;\n}\n\n.rt-define-jira-actions .generate-all-tests-btn,\n.rt-legacy-embed .generate-all-tests-btn {\n  background: var(--primary, #2563eb);\n  border-color: var(--primary, #2563eb);\n  color: #fff;\n}\n\n.rt-define-jira-actions .generate-all-scenarios-btn:disabled,\n.rt-define-jira-actions .generate-all-tests-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.rt-legacy-embed .jira-items-content,\n.rt-define-panel .jira-items-content {\n  background: transparent !important;\n  padding: 0 !important;\n}\n\n.rt-legacy-embed .epic-item,\n.rt-define-panel .epic-item,\n.rt-legacy-embed .story-item-card,\n.rt-define-panel .story-row {\n  background: var(--surface) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 10px !important;\n  color: var(--text-primary) !important;\n  box-shadow: none !important;\n}\n\n.rt-legacy-embed .stories-table,\n.rt-define-panel .stories-table {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  /* table chrome owned by rt2-jira-revamp — do not box every cell */\n  box-shadow: none !important;\n}\n\n.rt-legacy-embed .epic-header,\n.rt-define-panel .epic-header,\n.rt-legacy-embed .epic-summary,\n.rt-define-panel .epic-summary,\n.rt-legacy-embed .story-summary,\n.rt-define-panel .story-summary,\n.rt-legacy-embed .jira-key,\n.rt-define-panel .jira-key,\n.rt-legacy-embed .pagination-info,\n.rt-define-panel .pagination-info {\n  color: var(--text-primary) !important;\n}\n\n.rt-legacy-embed .jira-key,\n.rt-define-panel .jira-key {\n  color: var(--primary, #2563eb) !important;\n  font-weight: 600;\n}\n\n.rt-legacy-embed .epic-details,\n.rt-define-panel .epic-details,\n.rt-legacy-embed .epic-description,\n.rt-define-panel .epic-description {\n  color: var(--text-secondary, color-mix(in srgb, var(--text-primary) 70%, transparent)) !important;\n  border-color: var(--border) !important;\n}\n\n.rt-legacy-embed .sync-epic-btn,\n.rt-define-panel .sync-epic-btn,\n.rt-legacy-embed .generate-tests-btn,\n.rt-define-panel .generate-tests-btn,\n.rt-legacy-embed .generate-scenarios-btn,\n.rt-define-panel .generate-scenarios-btn {\n  border-radius: 8px !important;\n  border: 1px solid var(--border) !important;\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-legacy-embed .status-badge,\n.rt-define-panel .status-badge,\n.rt-legacy-embed .priority-badge,\n.rt-define-panel .priority-badge {\n  border-radius: 999px !important;\n  border: 1px solid var(--border);\n  background: color-mix(in srgb, var(--surface-2, var(--surface)) 90%, transparent) !important;\n  color: var(--text-primary) !important;\n}\n\n.rt-legacy-embed table th,\n.rt-define-panel table th {\n  background: var(--surface-2, color-mix(in srgb, var(--surface) 92%, var(--text-primary) 5%)) !important;\n  color: var(--text-secondary, var(--text-primary)) !important;\n  border-color: var(--border) !important;\n}\n\n.rt-legacy-embed table td,\n.rt-define-panel table td {\n  border-color: var(--border) !important;\n  color: var(--text-primary) !important;\n  background: var(--surface) !important;\n}\n\n[data-theme='cloudlight'] .rt-define-upload__card,\n:root:not([data-theme='midnight']) .rt-define-upload__card {\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n/* Dark-mode surfaces for Jira embed internals */\n.rt-define-panel .jira-items-content,\n.rt-legacy-embed .jira-items-content,\n.rt-define-panel .epic-details,\n.rt-legacy-embed .epic-details,\n.rt-define-panel .epic-dropdown,\n.rt-legacy-embed .epic-dropdown {\n  background: var(--surface) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border) !important;\n}\n\n.rt-define-panel .epic-details h4,\n.rt-define-panel .epic-stories h4,\n.rt-define-panel .test-case-section h4,\n.rt-legacy-embed .test-case-section h4 {\n  background: transparent !important;\n  box-shadow: none !important;\n  text-shadow: none !important;\n  color: var(--text-primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
